import { IconContainerWithButton } from 'components/DesignSystems/IconContainerWithButton/IconContainerWithButton';
import WizardButtonWrapper from '../Wizard/WizardButtonWrapper';
import { FlowType } from 'types/template';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';

type Props = {
  onModalClose: () => void;
  handleFlowSelect: (flow: FlowType) => void;
  handleStepTransition: () => void;
  selectedFlow: FlowType | null;
};

export default function SelectTemplateFlow({
  onModalClose,
  handleFlowSelect,
  handleStepTransition,
  selectedFlow,
}: Props) {
  return (
    <>
      <div className="w-100 d-flex flex-row gap-4">
        <IconContainerWithButton
          buttonText="Create New"
          description="Custom-build your team setup to match unique operational demands, ensuring a tailored approach to team roles and responsibilities."
          title="Create New"
          onButtonClick={() => handleFlowSelect('new')}
          icon="add"
          className={selectedFlow === 'new' ? 'selected' : ''}
        />
        <IconContainerWithButton
          buttonText="Use Existing"
          description="Implement existing Teams templates to expedite setup, leveraging established structures for quick operational integration."
          title="Use Existing Templates"
          onButtonClick={() => handleFlowSelect('existing')}
          icon="file_copy"
          className={selectedFlow === 'existing' ? 'selected' : ''}
        />
      </div>
      <WizardButtonWrapper onModalClose={onModalClose}>
        <StylishNewButton
          className="button--primary ms-2"
          onClick={handleStepTransition}
        >
          Next
        </StylishNewButton>
      </WizardButtonWrapper>
    </>
  );
}
